import { initialRaceState, IRaceState } from '../state/race.state';
import { RaceActions, ERaceActions } from '../actions/race.actions';

export const raceReducers = (
    state = initialRaceState,
    action: RaceActions
): IRaceState => {
    switch (action.type) {
        case ERaceActions.GetRaceSuccess: {
            return {
                ...state,
                race: action.payload
            };
        }

        default:
            return state;
    }
};
